import {useState, useEffect, useCallback} from 'react';

export const useDensities = (effect) => {
    let [isDensitiesMode, setIsDensitiesMode] = useState(false);
    let [densities, setDensities] = useState(effect.regions);
    let [selectedDensity, setSelectedDensity] = useState(undefined);

    const onClickDensity = useCallback((e, region) => {
        if (isDensitiesMode) {
            e.stopPropagation();
            setSelectedDensity(region);
        }
    }, [setSelectedDensity, isDensitiesMode]);

    useEffect(() => {
        setSelectedDensity(undefined);
    }, [setSelectedDensity, isDensitiesMode]);

    return {
        setIsDensitiesMode,
        isDensitiesMode,
        densities,
        setDensities,
        selectedDensity,
        onClickDensity,
        setSelectedDensity};
}
